import React, { useState } from "react";
import Filtro from './Filtro';
import Table from './Table';
import ReportAcordeon from '../../../Components/ReportAcordeon'
import { 
    getContentWithAcessInteration
} from "../../../../../services/NexiDigitalAPI";


const AcessInteration = ({ index, expanded }) => {
    const name = "Conteúdos acessados com interação"
    const description = "Exibe os conteúdos mais acessados com interação.";

    const [loading, setLoading] = useState(false);
    const [dados, setDados] = useState([]);

    const actionFilter = async (values) => {

        setLoading(true);
        // Sessions
        const responseData = await getContentWithAcessInteration(values);
        setDados(responseData);
   
        setLoading(false);
    }

    const filter = (
        <Filtro 
            actionFilter={actionFilter} 
            loading={loading} 
        />
    );

    const result = (
        <Table 
            dados={ dados } 
            loading={loading} 
        />
    );
    
    return (
        <ReportAcordeon
            name={name}
            description={description}
            filter={filter}
            result={result}
            index={ index }
            expanded={expanded}
        />
        
    )
}

export default AcessInteration;